// @ts-nocheck
import { Group } from './models/Group';
import { flow, getRoot, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Page } from '../common/enums';
import { RootStore } from './RootStore';
import { Datalist } from 'glamorous';

export const SearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  isActive: types.maybeNull(types.boolean),
});

export const GroupStore = types
  .compose(
    getBaseStore<Instance<typeof Group>, Instance<typeof Group>>(Group, 'groupId', 'group'),
    types.model('GroupStore', {}),
  )
  .views((self) => ({
    getGroupList() {
      return Datalist;
    },
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          groupId: undefined,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: Instance<typeof RootStore> = getRoot(self);
    const apiFetcher = env.api;

    const updateGroupInStore = (group: Instance<typeof Group>) => {
      const groupModel = Group.create(group);
      self.datas.put(groupModel);
      return groupModel;
    };

    const getByName = (name) => {
      return self.dataList.find((group) => group.name == name);
    };

    const saveGroup = flow(function*(group: Instance<typeof Group>) {
      const res = yield self.saveElement(group);
      // @ts-ignore
      if (group.groupId !== res.groupId) {
        // @ts-ignore
        root.ApplicationStore.navigate(`${Page.Groups}/${res.groupId}`);
      }
    });

    const refreshGroupPharmacyGeodata = flow(function*(groupId: number) {
      try {
        const result = yield env.api.postUnhandled('pharmacy/refreshGeoData/byGroup/' + groupId, {});
        return true;
      } catch (error) {
        return false;
      }
    });

    return {
      saveGroup,
      updateGroupInStore,
      refreshGroupPharmacyGeodata,
      getByName,
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
    };
  });

export type GroupStoreType = typeof GroupStore.Type;
